import { render, staticRenderFns } from "./inquirySkuList.vue?vue&type=template&id=a3010868&scoped=true"
import script from "./inquirySkuList.vue?vue&type=script&lang=js"
export * from "./inquirySkuList.vue?vue&type=script&lang=js"
import style0 from "./inquirySkuList.vue?vue&type=style&index=0&id=a3010868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3010868",
  null
  
)

export default component.exports